var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"showcase"},[_c('img',{attrs:{"src":require(("@/assets/" + _vm.uri)),"alt":""}}),_c('h1',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }